/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import SmartCollection from './smart_collection'
import MCPOption from './multiple_choice_poll_option'
import _ from 'underscore'

// @namespace Model
export default class MCPOptions extends SmartCollection {
  get model () { return MCPOption }

  highestResult () {
    return _.max(_(this.pluck('results_count')).map(num => parseFloat(num)))
  }

  lowestResult () {
    return _.min(_(this.pluck('results_count')).map(num => parseFloat(num)))
  }

  hasImage () {
    return this.any(option => option.isImage())
  }

  hasAlphaNumericKeyword () {
    return this.any(option => option.isKeywordAlphaNumeric())
  }

  hasLatex () {
    return this.any(option => option.isLatex())
  }

  hasCorrect () {
    return this.any(option => option.isCorrect())
  }

  resetKeywords (mcpOptions) {
    _.each(mcpOptions, option => {
      const existingOption = this.get(option.id)

      // reset the initial keyword in the keyword validator mixin
      return (existingOption != null ? existingOption.resetKeyword(_.pick(option, 'keyword', 'auto_keyword')) : undefined)
    })
  }

  ordinalRank (mcpOption) {
    if ((this.poll != null ? this.poll.type() : undefined) !== 'ranking_poll') { return }

    const resultCounts = this.map(model => model.get('results_count'))
    const sorted = _(resultCounts).sortBy(resultCount => parseFloat(resultCount))

    return _(sorted).indexOf(mcpOption.get('results_count')) + 1
  }
}
